import React from 'react';
const OcrCheckmarkIcon = () => (React.createElement("svg", { width: "12", height: "10", viewBox: "0 0 12 10", fill: "none" },
    React.createElement("path", { d: "M1 5L4.5 8.5L11 1.5", stroke: "#fff", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
export default OcrCheckmarkIcon;
